import { useQuery } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";
import { PublicationSummary } from "../types";

/** Every published post, newest first. Withdrawn and draft posts never appear. */
export const usePublications = () =>
  useQuery({
    queryKey: ["publications"],
    queryFn: async (): Promise<PublicationSummary[]> => {
      const { data } = await api.get<{ publications: PublicationSummary[] }>("/publications");
      return data.publications;
    },
    staleTime: 5 * 60 * 1000,
  });
